import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { compose } from 'recompose';
import { noneStyle } from '../../../helpers/common';
import { propArrayShape, propBool } from '../../../helpers/custom-prop-types';
import IsLoadingHoc from '../../Layout/Loading/IsLoadingHoc';
import MediaQuerySmallDeviceHoc from '../../Layout/MediaQuery/MediaQuerySmallDeviceHoc';
import CustomSlider from '../../Ui/Slider';
import ComparisonSection from './ComparisonSection';
const ComparisonSections = ({ isSmall, items }) => {
    if (items.length === 0) {
        return null;
    }
    return (_jsx("div", Object.assign({ className: 'l-container' }, { children: _jsxs("div", Object.assign({ className: 'comparison-container slide-container initialized' }, { children: [_jsxs(CustomSlider, Object.assign({ className: 'comparison-container', config: {
                        appendArrows: '.comparison-container',
                        arrows: true,
                        centerMode: true,
                        centerPadding: '48px',
                        infinite: false,
                        responsive: [
                            {
                                breakpoint: 480,
                                settings: {
                                    arrows: false,
                                    slidesToShow: 1,
                                },
                            },
                        ],
                        rows: 1,
                        slidesToShow: 3,
                    }, dataAttributes: {} }, { children: [items.map((item) => (_jsx(ComparisonSection, { item: item }, item.id))), !isSmall && _jsx("div", { style: noneStyle }), !isSmall && _jsx("div", { style: noneStyle })] })), _jsx("div", Object.assign({ className: 'comparison-status' }, { children: _jsxs("ul", { children: [_jsx("li", Object.assign({ className: 'budget' }, { children: "\u4E88\u7B97" })), _jsx("li", Object.assign({ className: 'budget' }, { children: "\u671F\u9593" })), _jsx("li", Object.assign({ className: 'artifact' }, { children: "\u6210\u679C\u7269" })), _jsx("li", Object.assign({ className: 'option' }, { children: "\u30AA\u30D7\u30B7\u30E7\u30F3" }))] }) }))] })) })));
};
ComparisonSections.propTypes = {
    isSmall: propBool().isRequired,
    items: propArrayShape().isRequired,
};
const enhance = compose(IsLoadingHoc, MediaQuerySmallDeviceHoc);
export default enhance(ComparisonSections);
